"use client"

import { useEffect } from "react"
import { saveUTMParams } from "@/lib/client-info"

/**
 * UTMTracker - автоматически сохраняет UTM метки в sessionStorage
 *
 * Использование:
 * Добавить в layout.tsx:
 * ```tsx
 * import UTMTracker from '@/components/atoms/UTMTracker'
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         <UTMTracker />
 *         {children}
 *       </body>
 *     </html>
 *   )
 * }
 * ```
 */
export default function UTMTracker() {
  useEffect(() => {
    // Сохраняем UTM метки при первой загрузке
    saveUTMParams()
  }, [])

  return null
}
